






















import { Component, Prop, Vue } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { UserModule } from '@/store/modules/user'
import SidebarItem from './SidebarItem.vue'
import PlatformConfig from '@/store/modules/config'
import variables from '@/styles/_variables.scss'

import request from '@/utils/request'
import $ from 'jquery'
@Component({
  name: 'SideBar',
  components: {
    SidebarItem
  }
})
export default class extends Vue {
  get sidebar() {
    return AppModule.sidebar
  }
  routeslist:any
  get routes() {
    // console.log((this.$router as any).options.routes)
    var list:any = []
    if (UserModule.token !== '') {
      $.ajax({
        url: PlatformConfig.baseServerUrlApi + '/SysModule/GetModuleByRoleID?t=' + Date.parse(new Date().toString()) / 1000, // url路径
        headers: {
          Authorization: 'Bearer ' + UserModule.token
        },
        type: 'GET', // GET
        async: false, // 或false,是否异步
        timeout: 5000, // 超时时间
        success: function(data:any) {
          this.routeslist = data.data
          list = data.data
        },
        error: function(xhr:any) {
          console.log('获取菜单失败' + xhr)
        }
      })
    }
    return list
    // return (this.$router as any).options.routes
  }

  // public async getList() {
  //   const data: any = await (request({
  //     url: '/SysModule/GetModuleByRoleID',
  //     method: 'GET'
  //   }))
  //   this.routeslist = data.data
  // }
  get variables() {
    return variables
  }

  get isCollapse() {
    return !this.sidebar.opened
  }
  // 初始化
  created() {
    // this.getList()
  }
}
